import { Component, OnInit, ViewChild } from '@angular/core';
import {
  CropperSettings,
  ImageCropperComponent,
  Bounds,
} from 'ngx-img-cropper';
import {
  ModalSize,
  SuiModalService,
  TemplateModalConfig,
  ModalTemplate,
} from '@richardlt/ng2-semantic-ui';
import { AppFilter, ConfirmModal } from 'src/modules/shared';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from 'src/modules/core/services';
import { OrganizationService } from 'src/modules/features/admin/services';

import {
  CompanyNameModal,
  CompanyDetailModal,
  CompanyInfoModal,
  CompanyPictureModal,
} from 'src/modules/features/contractor/modals';

@Component({
  selector: 'app-company',
  templateUrl: './company.component.html',
  styleUrls: ['./company.component.scss'],
})
export class CompanyComponent {
  @ViewChild('cropper') cropper: ImageCropperComponent;
  @ViewChild('uploadTemplate') public modalTemplate: ModalTemplate<
    any,
    string,
    string
  >;
  @ViewChild('organizationProfileTemplate')
  public organizationProfileModal: ModalTemplate<any, string, string>;
  success: any;
  error: any;
  pending: boolean;
  filter: AppFilter = new AppFilter();
  organization: any;
  cropperSettings: CropperSettings;
  mode = 'date';
  data = { image: 'assets/avatar/1.jpg' };

  permissions: any[];
  baseUrl = environment.API_SERVER;
  constructor(
    private modalService: SuiModalService,
    private location: Location,
    private activatedRoute: ActivatedRoute,
    private authSvc: AuthenticationService,
    private organizationSvc: OrganizationService
  ) {
    if (this.organization && this.organization.logoPath) {
      this.data.image = `${
        this.baseUrl
      }/public/image/?media=${this.organization.logoPath.replace(/\\/g, '/')}`;
    } else {
      this.data = { image: 'assets/avatar/1.jpg' };
    }
    this.cropperSettings = new CropperSettings();
    this.cropperSettings.noFileInput = true;
    this.cropperSettings.width = 380;
    this.cropperSettings.height = 300;

    this.cropperSettings.croppedWidth = 190;
    this.cropperSettings.croppedHeight = 150;

    this.cropperSettings.canvasWidth = 240;
    this.cropperSettings.canvasHeight = 140;

    this.organization = JSON.parse(window.localStorage.getItem('organization'));
    // this.activatedRoute.parent.params.subscribe((params) => {
    // 	// this.projectId = params['id'];
    // });
  }
  edit() {
    this.modalService
      .open(
        new CompanyNameModal(
          'Company Detail',
          this.organization,
          ModalSize.Tiny
        )
      )
      .onApprove((company: any) => {
        console.log(company);
        this.organization = { ...this.organization, ...company };
        console.log(this.organization);
        // window.localStorage.setItem('organization', JSON.stringify(this.organization));
      })
      .onDeny(() => {});
  }
  changeImage() {
    // this.modalService
    // 	.open(new ChangeLogoModal('Edit Logo', 'Are you sure you want to delete this Lot plan?', ModalSize.Tiny))
    // 	.onApprove(() => {})
    // 	.onDeny(() => {});
  }

  goBack() {
    this.location.back();
  }
  popModal() {
    const config = new TemplateModalConfig<any, string, string>(
      this.modalTemplate
    );
    config.isClosable = false;
    config.transitionDuration = 200;
    config.transition = 'slide left';
    config.size = ModalSize.Tiny;
    config.isFullScreen = false;
    config.isInverted = false;
    this.modalService
      .open(config)
      .onApprove((result) => {
        this.uploadImage(this.data.image);
      })
      .onDeny((result) => {
        /* deny callback */
      });
  }

  fileChangeListener($event) {
    // console.log($event)
    const image: any = new Image();
    const file: File = $event.target.files[0];
    const myReader: FileReader = new FileReader();
    const that = this;
    myReader.onloadend = (loadEvent: any) => {
      image.src = loadEvent.target.result;
      that.cropper.setImage(image);
    };
    myReader.readAsDataURL(file);
    // that.imageDone.emit(this.data.image)
  }

  uploadImage(event) {
    this.pending = true;
    this.error = false;
    this.organizationSvc
      .uploadLogoBase({
        organizationId: this.organization.organizationId,
        body: event,
      })
      .subscribe(
        (res) => {
          this.organization.logoPath = res['data'];
          this.data.image = `${this.baseUrl}/public/image/?media=${res[
            'data'
          ].replace(/\\/g, '/')}`;
          window.localStorage.setItem(
            'organization',
            JSON.stringify(Object.assign({}, this.organization))
          );
          setTimeout(() => {
            this.pending = false;
            this.success = 'Logo updated successfully';
            this.authSvc.setRefreshStorage('');
          }, 1000);
        },
        (error) => {
          this.pending = false;
          this.error = error.error;
        }
      );
  }
  ngOnInit(): void {}
  ngOnDestroy() {
    // unsubscribe all subsciptons
    // this.unsubscribe$.next();
    // this.unsubscribe$.complete();
  }
}
